import { render, staticRenderFns } from "./ServiceInvoicesRowsTable.vue?vue&type=template&id=70948687&scoped=true&"
import script from "./ServiceInvoicesRowsTable.vue?vue&type=script&lang=js&"
export * from "./ServiceInvoicesRowsTable.vue?vue&type=script&lang=js&"
import style0 from "./ServiceInvoicesRowsTable.vue?vue&type=style&index=0&id=70948687&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70948687",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardTitle,VIcon,VSpacer})
